import React from "react";
import "./Divider.css";

function Divider() {
    return (
        <div className="divider-container">
            <hr className="divider-line" />
        </div>
    );
}

export default Divider;